export const generateFormTemplateKey = (
	formTemplateGroup: string | undefined,
	formTemplateName: string,
) => {
	const processedGroup = formTemplateGroup?.trim().toLowerCase().replaceAll(' ', '-');
	const processedName = formTemplateName.trim().toLowerCase().replaceAll(' ', '-');
	return !processedGroup ? processedName : processedGroup?.concat('.', processedName);
};
